import { ThemedHistory as History } from './history';
export const ThemedHistory = History;
